<template>
  <gv-modal :modal="modal" :size="isMobile ? 'sm' : 'md'">
    <template #header>
      <div class="flex flex-row items-start rounded-t-lg bg-grey-25 p-4 text-[30px]">
        <div class="flex items-center gap-4">
          <img class="size-10" :src="IncidentNoTotalFireBan" alt="No Total fire ban" />

          <div class="flex flex-col">
            <gv-type :text="titleContent" dom-element="h1" variant="subtitle-sm" scheme="primary" />
            <gv-type :text="subtitleContent" scheme="secondary" />
          </div>
        </div>

        <gv-button
          class="ml-auto flex"
          variant="text"
          scheme="custom"
          size="custom"
          aria-label="Close"
          type="button"
          @click="modal.setClosed"
        >
          <gv-icon name="close" size="md" aria-label="Close" class="justify-self-end" />
        </gv-button>
      </div>
    </template>

    <template #default>
      <div class="flex flex-col gap-2 p-6 text-center">
        <gv-type :text="bodyHeadingContent" class="font-semibold" />
        <gv-type text="A Total Fire Ban could be declared at any time, and your local government may have other restrictions in place." />
        <button class="text-left" @click="onViewTotalFireBans">
          Check the
          <span class="text-indigo-500 underline">{{ bodyContent }}</span
          >.
        </button>
        <gv-type>
          More about
          <a class="text-indigo-500 underline" href="https://www.dfes.wa.gov.au/hazard-information/bushfire/total-fire-ban" target="_blank"
            >Total Fire Bans</a
          >.
        </gv-type>
      </div>
    </template>
  </gv-modal>
</template>

<script lang="ts" setup>
import { UseModal, isMobile } from '@/common';
import { computed } from 'vue';
import { DateTime } from 'luxon';
import { storeToRefs } from 'pinia';
import { useHazardsStore } from '@/features/hazards';
import { getDatetimeOrdinalSuffix } from '@/common/helpers';
import IncidentNoTotalFireBan from '@/common/assets/icons/hazards/incidents/ew-no-fire-ban.svg?url';

const props = defineProps<{
  modal: UseModal;
}>();

const hazardStore = useHazardsStore();

const { selectedDateIndex, dates } = storeToRefs(hazardStore);

const isToday = computed(() => dates.value[selectedDateIndex.value] === 'Today');

const titleContent = computed(() => `${isToday.value ? "Today's" : "Tomorrow's"} Total Fire Bans`);
const subtitleContent = computed(() => {
  const now = isToday.value ? DateTime.now().startOf('day') : DateTime.now().startOf('day').plus({ day: 1 });

  // day
  const day = now.toFormat('d');
  const daySuffix = getDatetimeOrdinalSuffix(now.day);
  const month = now.toFormat('MMMM');
  const year = now.toFormat('yyyy');

  return `${day}${daySuffix} ${month} ${year}`;
});

const bodyHeadingContent = computed(() => {
  return `No Total Fire Bans are current for ${isToday.value ? 'today' : 'tomorrow'}.`;
});

const bodyContent = computed(() => {
  return `Total Fire Bans for ${isToday.value ? 'tomorrow' : 'today'}`;
});

const onViewTotalFireBans = () => {
  props.modal.setClosed();
  hazardStore.setSelectedDateIndex(isToday.value ? 1 : 0);
};
</script>
